import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import DetailView from '../Common/DetailView';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import { Card, CardText, CardTitle } from 'material-ui/Card';
import buildContextMenu from '../Common/BuildContextMenu';

import SettingActions from '../../actions/SettingActionCreator';
import SettingStore from '../../stores/SettingStore';

class Help extends Component {

    componentDidMount() {
        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});
        SettingActions.getAll();
    }

    render() {

        const linkHelpGuides    = 'https://support.premierit.com/hc/en-us/sections/360000075329-Cortex';
        // const linkDocumentation = 'https://support.premierit.com/hc/en-us/sections/360000074025-Cortex';
        // const linkTutorials     = 'https://support.premierit.com/hc/en-us/sections/360000073985-Centric';
        // const linkSupportEmail  = 'mailto:support@premierit.com';

        return (

            <DetailView
                title='Help'
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardTitle
                            title='Product support'
                            subtitle='Technical support, documentation'
                        />
                        <CardText>
                            <article>
                                <h3>Documentation</h3>
                                <p>Browse our on-line <a href={linkHelpGuides} target="_blank">help guides</a>.</p>
                            </article>
                        </CardText>
                        {(!!this.state.supportEmail || !!this.state.supportPhone) && (
                            <CardText>
                                <article>
                                    <h3>Contact</h3>
                                    {!!this.state.supportEmail && (<p><strong>Email:</strong> {this.state.supportEmail}</p>)}
                                    {!!this.state.supportPhone && (<p><strong>Tel.:</strong> {this.state.supportPhone}</p>)}
                                </article>
                            </CardText>
                        ) }
                        <CardText>
                            <article>
                                <h3>Browser information</h3>
                                <p><strong>User Agent:</strong> {navigator.userAgent}</p>
                                <p><strong>Platform:</strong> {navigator.platform}</p>
                                <p><strong>Language:</strong> {navigator.language}</p>
                                <p><strong>Cookies enabled:</strong> {navigator.cookieEnabled ? 'yes' : 'no'}</p>
                                <p><strong>Plugins:</strong> {Array.from(navigator.plugins).map(({name}) => name).join(', ')}</p>
                            </article>
                        </CardText>
                    </Card>
                </div>
            </DetailView>
        )
    }
}

Help.getStores = () => [SettingStore];
Help.calculateState = (prevState) => {
    return ({
        actions: (!!prevState && prevState.actions) || [],
        menuItems: [{
            link: '/logout',
            icon: <CancelIcon/>,
            label: 'Sign out',
        }],
        links: {
            back: '/dashboard',
        },
        supportEmail: SettingStore.getValue('SUPPORT_EMAIL'),
        supportPhone: SettingStore.getValue('SUPPORT_PHONE'),
    });
};

Help.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Container.create(Help);
